import { render, staticRenderFns } from "./rp-roles-wellcome.vue?vue&type=template&id=8efee140"
import script from "./rp-roles-wellcome.vue?vue&type=script&lang=js"
export * from "./rp-roles-wellcome.vue?vue&type=script&lang=js"
import style0 from "./rp-roles-wellcome.vue?vue&type=style&index=0&id=8efee140&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports